import { render, staticRenderFns } from "./HeatingMeter.vue?vue&type=template&id=5482d48f&scoped=true&"
import script from "./HeatingMeter.vue?vue&type=script&lang=ts&"
export * from "./HeatingMeter.vue?vue&type=script&lang=ts&"
import style0 from "./HeatingMeter.vue?vue&type=style&index=0&id=5482d48f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5482d48f",
  null
  
)

export default component.exports